import React, { useRef } from 'react';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { getTableTextColor } from 'apps/auth/helpers/historyUtils';
import { useAuth, useCheck, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

import CheckTableRow from './CheckTableRow';
import PaymentDetailCopyPopup from '../popups/PaymentDetailCopyPopup';

const DateTransferIdUnit = ({ getFormattedChequeDate }) => {
    const { chequeDate, chequeOperationNumber, sharedTransactionInfo, sharedTransactionCopyInfo, paymentCopyButton } = usePageMessages();
    const cheque = useCheck();
    const { countryId: userCountryId } = useAuth();
    const { lang } = useLanguage();

    const popupRef = useRef(null);

    const CopyPopup = (
        <PaymentDetailCopyPopup
            paymentCopyButton={paymentCopyButton}
            copyDetails={sharedTransactionCopyInfo}
            info={<DangerouslyHtml dangerouslyHtml={sharedTransactionInfo} />}
            popupRef={popupRef}
        />
    );

    return (
        <>
            <Separator marginTop="16px" />
            <TableContainer>
                <CheckTableRow title={chequeDate} cheque={cheque}>
                    {getFormattedChequeDate(userCountryId, cheque.date, lang)}
                </CheckTableRow>
                <CheckTableRow title={chequeOperationNumber} cheque={cheque}>
                    <Row flex align="center">
                        {cheque.paymentId}
                        <DiskButton
                            size="small"
                            iconName="info-rounded"
                            iconColor={getTableTextColor(cheque)}
                            type="button"
                            raised={false}
                            onClick={() => {
                                popupRef.current?.open(CopyPopup);
                            }}
                        />
                    </Row>
                </CheckTableRow>
            </TableContainer>
            <PopupNew ref={popupRef} getPopupComponent={(component) => component} />
        </>
    );
};

export default DateTransferIdUnit;
